import { render, staticRenderFns } from "./ViewTreatReport.vue?vue&type=template&id=6d4091b8&scoped=true"
import script from "./ViewTreatReport.vue?vue&type=script&lang=js"
export * from "./ViewTreatReport.vue?vue&type=script&lang=js"
import style0 from "./ViewTreatReport.vue?vue&type=style&index=0&id=6d4091b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4091b8",
  null
  
)

export default component.exports